import type { GridColumnVisibilityModel } from "@mui/x-data-grid-pro";

import { DashboardDataGridField } from "~/feature/dashboard/components/DashboardDataGrid/types";

export const getVisibleDashboardFields = (
  hidden: ReadonlySet<DashboardDataGridField>
): DashboardDataGridField[] =>
  Object.values(DashboardDataGridField).filter((field) => !hidden.has(field));

export const buildColumnVisibilityModel = (
  hidden: ReadonlySet<string>,
  alwaysHidden: readonly string[] = []
): GridColumnVisibilityModel =>
  Object.fromEntries(
    [...hidden, ...alwaysHidden].map((field) => [field, false])
  );

export const setHiddenField = (
  hidden: ReadonlySet<DashboardDataGridField>,
  field: DashboardDataGridField,
  visible: boolean
): Set<DashboardDataGridField> => {
  const next = new Set(hidden);

  if (visible) {
    next.delete(field);
  } else {
    next.add(field);
  }

  return next;
};
